import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  useDrawer,
  Conditional
} from '@cat-ecom/pcc-components';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { CatIconArrowBack } from 'blocks-nextjs/blocks-react/components/Icons/ArrowBack';
import { useTranslations } from 'next-intl';
import { StoreAddress } from 'components/dealer-locator/types';
import { NotificationContactDealerBody } from '../components/notification-contact-dealer-body';
import { NotificationContactDealerSkeleton } from '../components/notification-contact-dealer-skeleton';
import { Notification } from 'services/notifications/types';

export const NotificationContactDealerDrawer = ({
  drawer,
  storeAddress,
  notification
}: {
  drawer: ReturnType<typeof useDrawer>;
  storeAddress: StoreAddress;
  notification: Notification;
}) => {
  const t = useTranslations();
  return (
    <Drawer {...drawer.drawerProps}>
      <DrawerHeader className={'d-flex align-items-center text-capitalize'}>
        <CatButton
          className="me-2"
          hideText
          onClick={drawer.closeDrawer}
          variant="ghost"
        >
          <CatIconArrowBack slot="before" />
        </CatButton>
        <CatHeading
          variant="title"
          slot="header"
          className="cat-u-theme-typography-title-sm"
        >
          {t('SOS_CONTACT_DEALER')}
        </CatHeading>
      </DrawerHeader>
      <DrawerBody className="p-3 ps-4">
        <Conditional
          test={!!storeAddress}
          fallback={<NotificationContactDealerSkeleton />}
        >
          <NotificationContactDealerBody
            handleClickClose={drawer.closeDrawer}
            storeAddress={storeAddress}
            notification={notification}
          />
        </Conditional>
      </DrawerBody>
      <DrawerFooter>
        <CatButton className="me-2" onClick={drawer.closeDrawer}>
          {t('CANCEL')}
        </CatButton>
      </DrawerFooter>
    </Drawer>
  );
};
